<template>
  <span :class="`svg ${type}`">
    <svg
      v-if="type === 'home'"
      :width="width"
      :height="height"
      viewBox="0 0 23.7 21.6"
    >
      <path d="M20.1,21.6h-6c-0.3,0-0.6-0.3-0.6-0.6v-6c0-0.5-0.4-0.9-0.9-0.9h-1.5c-0.5,0-0.9,0.4-0.9,0.9v6c0,0.3-0.3,0.6-0.6,0.6h-6 C3.3,21.6,3,21.3,3,21v-8.2c0-0.3,0.3-0.6,0.6-0.6s0.6,0.3,0.6,0.6v7.7H9V15c0-1.2,0.9-2.1,2.1-2.1h1.5c1.2,0,2.1,0.9,2.1,2.1v5.4 h4.8v-7.7c0-0.3,0.3-0.6,0.6-0.6s0.6,0.3,0.6,0.6V21C20.7,21.3,20.4,21.6,20.1,21.6z"/>
      <path d="M23.1,11.8c-0.2,0-0.3-0.1-0.4-0.2L12.5,1.4c-0.3-0.3-0.9-0.3-1.3,0L1,11.6c-0.2,0.2-0.6,0.2-0.8,0s-0.2-0.6,0-0.8L10.4,0.6 c0.8-0.8,2.2-0.8,3,0l10.2,10.2c0.2,0.2,0.2,0.6,0,0.8C23.4,11.7,23.3,11.8,23.1,11.8z"/>
    </svg>

    <svg
      v-else-if="type === 'profile'"
      :width="width"
      :height="height"
      viewBox="0 0 21 21"
    >
      <path d="M0.9,20.2c0.1-0.3,0.2-0.6,0.2-1c0.4-1.5,1.1-2.9,2.1-4.1c1.1-1.2,2.3-2.1,3.7-2.7c0.3-0.2,0.6-0.2,1-0.4 c-0.3-0.2-0.6-0.4-0.8-0.6c-1-0.8-1.7-1.8-2-3C4.8,7.7,4.8,6.8,4.8,6C4.8,4.8,5.2,3.7,6,2.7c0.8-1.3,2-2,3.5-2.5 c0.3-0.1,0.6-0.1,0.8-0.2c0,0,0.1,0,0.1-0.1c0.5,0,0.9,0,1.3,0c0.3,0.1,0.5,0.1,0.8,0.2c1.7,0.5,3.1,1.4,4,3 c0.5,0.8,0.7,1.5,0.8,2.3c0.2,1.3,0,2.6-0.6,3.7c-0.6,1.1-1.4,2-2.6,2.7c0.2,0.1,0.3,0.2,0.5,0.2c1.1,0.5,2.1,1,3,1.8 c1.1,1,2.1,2.2,2.7,3.6c0.4,0.8,0.6,1.7,0.8,2.7c0.1,0.3,0,0.5-0.2,0.8c-0.4,0.3-0.9,0.2-1-0.4c-0.2-0.5-0.2-1.1-0.4-1.7 c-0.4-1.1-0.9-2.1-1.7-3c-0.9-1.1-2-1.9-3.2-2.5c-0.8-0.4-1.7-0.6-2.6-0.8c-1.7-0.2-3.3,0.1-4.9,0.8c-1.9,1-3.3,2.4-4.2,4.4 c-0.4,0.8-0.7,1.7-0.8,2.6c0,0.2-0.3,0.5-0.5,0.5c-0.3,0.1-0.6-0.1-0.8-0.4c0,0,0-0.1-0.1-0.1C0.9,20.5,0.9,20.4,0.9,20.2z M11,1.2 c-0.2,0-0.2,0-0.4,0C9.1,1.4,7.9,2,6.9,3.3C6,4.4,5.6,5.8,5.9,7.2c0.3,1.7,1.3,3,2.8,3.7c1.1,0.5,2.2,0.8,3.4,0.5 c1.2-0.2,2.3-0.8,3.1-1.8c0.9-1.1,1.3-2.3,1.1-3.7c-0.2-1.4-0.8-2.4-1.8-3.3C13.5,1.7,12.3,1.2,11,1.2z"/>
    </svg>

    <svg
      v-else-if="type === 'chevron-right'"
      :width="width"
      :height="height"
      viewBox="0 0 4.6 7.5"
    >
      <path d="M0,6.6l2.9-2.9L0,0.9L0.9,0l3.7,3.8L0.9,7.5L0,6.6z"/>
    </svg>

    <svg
      v-else-if="type === 'chevron-left'"
      :width="width"
      :height="height"
      viewBox="0 0 4.6 7.5"
    >
      <path d="M4.6,0.9L1.7,3.8l2.9,2.8L3.7,7.5L0,3.7L3.7,0L4.6,0.9z"/>
    </svg>

    <svg
      v-else-if="type === 'chevron-down'"
      :width="width"
      :height="height"
      viewBox="0 0 12 6.6"
    >
      <path d="M0,1.1L1.2,0L6,4.7L10.8,0L12,1.1L6.7,6.3c-0.4,0.4-1,0.4-1.4,0L0,1.1z"/>
    </svg>

    <svg
      v-else-if="type === 'chevron-up'"
      :width="width"
      :height="height"
      viewBox="0 0 12 6.6"
    >
      <path d="M12,5.5l-1.2,1.1L6,1.9L1.2,6.6L0,5.5l5.3-5.2c0.4-0.4,1-0.4,1.4,0L12,5.5z"/>
    </svg>

    <svg
      v-else-if="type === 'check'"
      :width="width"
      :height="height"
      viewBox="0 0 19 14"
    >
      <path d="M5.88 11.06L1.54 6.72L0 8.12L5.88 14L18.34 1.54L16.94 0L5.88 11.06Z"/>
    </svg>

    <svg
      v-else-if="type === 'add'"
      :width="width"
      :height="height"
      viewBox="0 0 11 11"
    >
      <path d="M10.7897 6.31571H6.21073V10.8947H4.68442V6.31571H0.105469V4.7894H4.68442V0.210449H6.21073V4.7894H10.7897V6.31571Z" />
    </svg>

    <svg
      v-else-if="type === 'remove'"
      :width="width"
      :height="height"
      viewBox="0 0 12 3"
    >
      <path d="M11.6578 2.31587H0.973633V0.789551H11.6578V2.31587Z" />
    </svg>

    <svg
      v-else-if="type === 'close'"
      :width="width"
      :height="height"
      viewBox="0 0 11.7 11.7"
    >
      <polygon points="11.7,1.1 10.6,0 5.8,4.8 1.1,0 0,1.1 4.8,5.8 0,10.6 1.1,11.7 5.8,6.9 10.6,11.7 11.7,10.6 6.9,5.8 "/>
    </svg>

    <svg
      v-else-if="type === 'agenda'"
      :width="width"
      :height="height"
      viewBox="0 0 24 20.5"
    >
      <path d="M24,2.3c0-0.1,0-0.1-0.1-0.2c-0.1-0.1-0.1-0.3-0.1-0.5c-0.4-0.9-1.1-1.4-2.1-1.5c-1.1-0.1-2.2-0.1-3.1,0 c-1.5,0.1-2.8,0.4-4,0.9c-0.7,0.2-1.2,0.6-1.9,0.9L12.1,2C12,2.1,12,2.1,11.9,2c-1.5-0.8-3.1-1.4-4.7-1.8C5.7,0,4.2-0.1,2.6,0.1 C2.1,0.1,1.6,0.1,1.2,0.4C0.4,0.9,0,1.6,0,2.6c0,2.8,0,5.6,0,8.4v3.8c0,0.5,0,1.1,0,1.6c0,1.2,0.7,2.1,2,2.4 c0.4,0.1,0.9,0.1,1.3,0.1h0.2c0.4,0,0.9,0,1.3,0.1C5.6,19,6.3,19,7.1,19c1.8,0.1,3.4,0.7,4.7,1.5h0.1h0.4h0.1 c0.7-0.4,1.4-0.7,2.4-0.9c1-0.2,2.1-0.5,3.1-0.7c1-0.1,2.1-0.2,3.1-0.1c0.6,0.1,1.2,0.1,1.7-0.1c0.7-0.4,1.2-0.9,1.3-1.8v-0.1v-0.1 V2.3z M22.8,2.6v13.8c0,0.4-0.1,1-0.8,1.2c-0.2,0.1-0.4,0.1-0.7,0.1c-1.7-0.2-3.4-0.1-5.3,0.3l-0.3,0.1c-0.9,0.2-2,0.4-2.9,0.8 C12.8,19,12.7,19,12.6,19v-2.3c0-4.5,0-9,0-13.6c0-0.1,0-0.1,0.1-0.2c1.7-0.9,3.4-1.5,5.2-1.8c0.7-0.1,1.4-0.1,2-0.1 c0.7,0,1.2,0.1,1.8,0.1c0.6,0.1,1,0.5,1.1,1.2C22.8,2.5,22.8,2.6,22.8,2.6z M11.5,19c-0.1,0-0.1-0.1-0.2-0.1c-0.4-0.1-0.7-0.3-1-0.4 c-1.2-0.4-2.7-0.7-4.3-0.7c-0.5,0-1.1,0-1.6-0.1c-0.5,0-1.1,0-1.6-0.1c-0.4,0-0.7-0.1-1-0.3c-0.3-0.2-0.4-0.4-0.5-0.8 c0-0.1,0-0.1,0-0.2V2.6c0-0.9,0.4-1.3,1.3-1.4c0.6-0.1,1.1-0.1,1.7-0.1c0.4,0,0.9,0,1.3,0.1C6.9,1.4,8,1.6,9,2 c0.5,0.2,1,0.4,1.5,0.7c0.3,0.1,0.6,0.3,0.9,0.4v0.1V19z"/>
    </svg>

    <svg
      v-else-if="type === 'ticket'"
      :width="width"
      :height="height"
      viewBox="0 0 21.7 21.6"
    >
      <path d="M19.3,5.3l1.7,1.8c0.8,0.8,0.8,2.1,0,2.9L9.9,21c-0.8,0.8-2.1,0.8-2.9,0l-1.7-1.8c0.8-0.8,0.8-2.1,0-2.9 c-0.8-0.8-2.1-0.8-2.9,0l-1.7-1.8c-0.8-0.8-0.8-2.1,0-2.9L11.8,0.6c0.8-0.8,2.1-0.8,2.9,0l1.7,1.8c-0.8,0.8-0.8,2.1,0,2.9 S18.5,6.1,19.3,5.3z M7,7.9l1.1,1.1c0.2,0.2,0.4,0.2,0.6,0l0.5-0.5c0.2-0.2,0.2-0.4,0-0.6L8.1,6.9c-0.2-0.2-0.4-0.2-0.6,0L7,7.4 C6.8,7.5,6.8,7.8,7,7.9z M10.9,12l-1.1-1.1c-0.2-0.2-0.2-0.4,0-0.6l0.5-0.5c0.2-0.2,0.4-0.2,0.6,0l1.1,1.1c0.2,0.2,0.2,0.4,0,0.6 L11.5,12C11.4,12.1,11.1,12.1,10.9,12z M12.5,13.6l1.1,1.1c0.2,0.2,0.4,0.2,0.6,0l0.5-0.5c0.2-0.2,0.2-0.4,0-0.6l-1.1-1.1 c-0.2-0.2-0.4-0.2-0.6,0L12.5,13C12.3,13.1,12.3,13.4,12.5,13.6z"/>
    </svg>

    <svg
      v-else-if="type === 'heart'"
      :width="width"
      :height="height"
      viewBox="0 0 19.2 17"
    >
      <path d="M18.8,3.4c-0.3-0.7-0.7-1.2-1.2-1.8v0c-0.5-0.5-1.1-0.9-1.8-1.2c-1.3-0.5-2.8-0.5-4.1,0c-0.7,0.3-1.3,0.7-1.8,1.2L9.6,2 L9.2,1.6C8.2,0.6,6.8,0,5.4,0S2.6,0.6,1.6,1.6C0.5,2.6,0,4,0,5.4s0.6,2.8,1.6,3.8l7.5,7.5C9.2,16.9,9.4,17,9.6,17s0.4-0.1,0.5-0.2 l7.5-7.5c0.5-0.5,0.9-1.1,1.2-1.8c0.3-0.7,0.4-1.4,0.4-2.1S19.1,4,18.8,3.4z"/>
    </svg>

    <svg
      v-else-if="type === 'heart-bordered'"
      :width="width"
      :height="height"
      viewBox="0 0 20.2 18"
    >
      <path class="st0" d="M19.3,3.9c-0.3-0.7-0.7-1.2-1.2-1.8l0,0c-0.5-0.5-1.1-0.9-1.8-1.2c-1.3-0.5-2.8-0.5-4.1,0 c-0.7,0.3-1.3,0.7-1.8,1.2l-0.3,0.4L9.7,2.1c-1-1-2.4-1.6-3.8-1.6S3.1,1.1,2.1,2.1C1,3.1,0.5,4.5,0.5,5.9s0.6,2.8,1.6,3.8l7.5,7.5 c0.1,0.2,0.3,0.3,0.5,0.3s0.4-0.1,0.5-0.2l7.5-7.5C18.6,9.3,19,8.7,19.3,8c0.3-0.7,0.4-1.4,0.4-2.1S19.6,4.5,19.3,3.9z"/>
    </svg>

    <svg
      v-else-if="type === 'share'"
      :width="width"
      :height="height"
      viewBox="0 0 16 16"
    >
      <path class="st0" d="M11.3,4.3c0.5,0.6,1.2,1,2.1,1c1.4,0,2.6-1.2,2.6-2.6S14.8,0,13.4,0c-1.5,0-2.6,1.2-2.6,2.6 c0,0.2,0,0.5,0.1,0.7l-6.1,3c-0.5-0.6-1.2-1-2.1-1C1.2,5.4,0,6.5,0,8c0,1.5,1.2,2.6,2.6,2.6c0.8,0,1.6-0.4,2.1-1l6.1,3 c-0.1,0.2-0.1,0.4-0.1,0.7c0,1.5,1.2,2.6,2.6,2.6c1.4,0,2.6-1.2,2.6-2.6c0-1.5-1.2-2.6-2.6-2.6c-0.8,0-1.6,0.4-2.1,1l-6.1-3 C5.2,8.5,5.3,8.2,5.3,8c0-0.2,0-0.5-0.1-0.7L11.3,4.3z"/>
    </svg>

    <svg
      v-else-if="type === 'message-success'"
      width="111"
      height="111"
      viewBox="0 0 111 111"
      fill="none"
    >
      <circle cx="55.5" cy="55.5" r="54" stroke="#43D71E" stroke-width="3"/>
      <path d="M47.0687 65.44L35.9466 54.28L32 57.88L47.0687 73L79 40.96L75.4122 37L47.0687 65.44Z" fill="#43D71E"/>
    </svg>

    <svg
      v-else-if="type === 'message-error'"
      width="111"
      height="111"
      viewBox="0 0 111 111"
      fill="none"
    >
      <circle cx="55.5" cy="55.5" r="54" stroke="#FF1E24" stroke-width="3"/>
      <path d="M37 74L73 38" stroke="#FF1E24" stroke-width="5"/>
      <path d="M37 38L73 74" stroke="#FF1E24" stroke-width="5"/>
    </svg>

    <svg
      v-else-if="type === 'message-loading'"
      viewBox="0 0 110 114"
      width="110"
      height="114"
    >
      <path d="M65.4,9.2c0,5-4,9.2-9.2,9.2c-5,0-9.2-4-9.2-9.2C47,4,51,0,56.2,0C61.1,0,65.4,4,65.4,9.2z"/>
      <path class="st0" style="fill:#141414;" d="M38.2,12.1c2.2,3.9,0.9,9-2.9,11.2c-3.9,2.2-9,0.9-11.2-2.9c-2.2-3.9-0.9-9,2.9-11.2C30.8,6.8,36,8.1,38.2,12.1 z"/>
      <path class="st1" style="fill:#292929;" d="M16.5,28.5c3.5,2,4.6,6.4,2.8,9.9c-2,3.5-6.4,4.6-9.9,2.8c-3.5-2-4.6-6.4-2.8-9.9C8.6,27.7,13,26.4,16.5,28.5z" />
      <path class="st2" style="fill:#3D3D3D;" d="M6.4,53.6c3.5,0,6.4,2.9,6.4,6.4s-2.9,6.4-6.4,6.4S0,63.5,0,60S2.9,53.6,6.4,53.6z"/>
      <path class="st3" style="fill:#525252;" d="M10.6,80.4c2.6-1.5,5.9-0.6,7.5,2c1.5,2.6,0.6,5.9-2,7.5c-2.6,1.5-5.9,0.6-7.5-2C7.2,85.2,8.1,81.9,10.6,80.4z" />
      <path class="st4" style="fill:#666666;" d="M28.1,101.2c1.3-2.2,4-2.9,6.2-1.7c2.2,1.3,2.9,4,1.7,6.2c-1.3,2.2-4,2.9-6.2,1.7 C27.5,106.1,26.8,103.4,28.1,101.2z"/>
      <path class="st5" style="fill:#7A7A7A;" d="M53.2,109.8c0-2.2,1.8-4,4-4s4,1.8,4,4s-1.8,4-4,4C55.1,114,53.2,112.2,53.2,109.8z"/>
      <path class="st6" style="fill:#8F8F8F;" d="M79.3,104.6c-0.9-1.7-0.4-4,1.3-5c1.7-0.9,4-0.4,5,1.3c0.9,1.7,0.4,4-1.3,5C82.4,107,80.2,106.5,79.3,104.6z"/>
      <path class="st7" style="fill:#A3A3A3;" d="M99.1,87c-1.5-0.9-2-2.8-1.1-4.4c0.9-1.5,2.8-2,4.4-1.1c1.5,0.9,2,2.8,1.1,4.4C102.4,87.4,100.6,87.7,99.1,87z" />
      <path class="st8" style="fill:#B8B8B8;" d="M107.2,61.7c-1.5,0-2.8-1.3-2.8-2.8c0-1.5,1.3-2.8,2.8-2.8c1.5,0,2.8,1.3,2.8,2.8 C109.8,60.4,108.7,61.7,107.2,61.7z"/>
      <path class="st9" style="fill:#CFCFCF;" d="M101.2,35.8c-1.1,0.6-2.6,0.2-3.1-0.9c-0.6-1.1-0.2-2.6,0.9-3.1c1.1-0.6,2.4-0.2,3.1,0.9 C102.6,33.8,102.3,35.1,101.2,35.8z"/>
      <path class="st10" style="fill:#E6E6E6;" d="M83,16.5c-0.6,0.9-1.7,1.1-2.6,0.7c-0.9-0.6-1.1-1.7-0.7-2.6c0.6-0.9,1.7-1.1,2.6-0.7 C83.2,14.5,83.5,15.6,83,16.5z"/>
    </svg>

    <svg
      v-else-if="type === 'play'"
      :width="width"
      :height="height"
      viewBox="0 0 21 20"
    >
    <path class="st0" d="M8.7,5.6v8.9l5.6-4.4L8.7,5.6z M18.7,0H3.2C1.9,0,0.9,1,0.9,2.2v15.6c0,1.2,1,2.2,2.2,2.2h15.6c1.2,0,2.2-1,2.2-2.2V2.2C20.9,1,19.9,0,18.7,0z M19.7,18.8H2.2V1.2h17.6V18.8z"/>
    </svg>

    <svg v-else-if="type === 'multimedia-play'"
      :width="width"
      :height="height"
      viewBox="0 0 48 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="23.5" r="23.5" fill="#FF1E24"/>
      <path d="M17.5 23V15.7098C17.5 14.945 18.3237 14.4633 18.9903 14.8383L31.9505 22.1284C32.6302 22.5107 32.6302 23.4893 31.9505 23.8716L18.9903 31.1617C18.3237 31.5367 17.5 31.055 17.5 30.2902V23Z" fill="white"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 16
    },
    height: {
      type: Number,
      default: 16
    }
  }
};
</script>

<style lang="scss" scoped>
.svg {
  display: inline-block;

  svg {
    display: block;
  }
}
</style>
